import axios from 'axios';
import type { AxiosInstance } from 'axios';
import { getTokens } from '@rsos/sinatra';
import { PRODUCT_TOKEN } from '@rsos/sinatra/src/actions/types';
import { getAPIHost } from '@rsos/utils/metaTags';
import type { KeywordSet } from './KeywordSet';
import { KeywordTier } from './KeywordTier';

export class KeywordAPI {
  psapAPI: AxiosInstance;
  capstoneProductAPI: AxiosInstance;

  constructor(orgName?: string) {
    this.psapAPI = axios.create({
      baseURL: `${getAPIHost()}/v1/capstone/psaps/${orgName}`,
      headers: { Authorization: `Bearer ${getTokens()?.token}` },
      withCredentials: true,
    });

    this.capstoneProductAPI = axios.create({
      baseURL: `${getAPIHost()}/v1/`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem(PRODUCT_TOKEN)}`,
      },
      withCredentials: false,
    });
  }

  fetchKeywordSets(): Promise<KeywordSet[]> {
    return this.psapAPI.get(`/keywordsets`).then(r => r.data);
  }

  saveKeywordSets(keywordsets: KeywordSet[]): Promise<KeywordSet[]> {
    return this.psapAPI.patch(`/keywordsets`, keywordsets).then(r => r.data);
  }

  fetchKeywordTiers(): Promise<KeywordTier[]> {
    return this.psapAPI.get(`/keyword_tiers`).then(r => r.data);
  }

  updateKeywordTiers(tiers: KeywordTier[]): Promise<KeywordTier[]> {
    return this.psapAPI.patch(`/keyword_tiers`, tiers).then(r => r.data);
  }

  fetchKeywordRecommendations(
    keywordset: KeywordSet,
    matches = 10,
  ): Promise<string[]> {
    return this.capstoneProductAPI
      .post(`/lingohub/relatedkeywords`, {
        'keyword-set': keywordset,
        'max-matches': matches,
      })
      .then(r => r.data['related-keywords']);
  }
}
